const PRODUCTION_API_BASE_URL = "https://api.ringoi.com";

export const resolveApiBaseUrl = (configuredUrl, fallback = PRODUCTION_API_BASE_URL) => {
  const configured = String(configuredUrl || "").trim();
  const resolved = configured || String(fallback || "").trim();
  return resolved.replace(/\/+$/, "");
};

// Builds can now target staging/local APIs without editing source files. The
// production URL remains the safe fallback when the variable is not supplied.
export const baseURL = resolveApiBaseUrl(process.env.REACT_APP_API_BASE_URL);
